module.exports = __webpack_public_path__ + "img/defence-academy-24.bf86961d.svg";